import cn from 'classnames';
import * as React from 'react';

import s from './BaseStub.module.scss';

export enum BaseStubSize {
  fitContainer = 'fit-container',
  unset = 'unset',
}

type BaseStubProps = {
  imageNode: React.ReactNode;
  textNode?: React.ReactNode;
  className?: string;
  size?: BaseStubSize;
};

const BaseStub: React.FC<BaseStubProps> = ({
  imageNode,
  textNode,
  size = BaseStubSize.unset,
  className,
}) => {
  return (
    <div className={cn(size && s[`base-stub_${size}`], className)}>
      <div className={s.baseStub__content}>
        {imageNode}
        {textNode}
      </div>
    </div>
  );
};

export default BaseStub;
